import { useLang } from "@/context/LangContext";
import HowItWorksTopSection from "@/components/landing/HowItWorksTopSection";
import HowItWorksPart2 from "@/components/landing/HowItWorksPart2";

// Public How It Works marketing page.
//
// Composed as: PublicHeader (rendered inside the top section) +
// HowItWorksTopSection (Part 1 of 2). The bottom section will be
// added in a subsequent authorized pass.
//
// This page is a public marketing route — no auth required, no
// contractor data exposed. It renders the approved PO visual
// reference exclusively with live React UI over the approved
// background canvas at
// /brand/how-it-works/how_it_works_top_env_canvas.png.
export default function HowItWorks() {
  const { lang, setLang } = useLang();
  return (
    <div className="min-h-screen bg-white" data-testid="how-it-works-root">
      <HowItWorksTopSection lang={lang} setLang={setLang} />
      <HowItWorksPart2 lang={lang} />
    </div>
  );
}
